// ZoofyTechX - Mock data (frontend-only teaser, to be replaced by backend APIs later)

export const heroSlides = [
  {
    id: 1,
    tag: "Security Solutions",
    image: "https://images.unsplash.com/photo-1653549893012-b8b4fbe97630?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwyfHxjeWJlcnNlY3VyaXR5JTIwbmV0d29ya3xlbnwwfHx8Ymx1ZXwxNzkwNDI2NDUxfDA&ixlib=rb-4.1.0&q=85",
    title: ["Build A Business", "That Cyber Threats", "Can't Stop"],
    subtitle: "Expect threats. Fear nothing. Zero-trust security engineered for the modern enterprise.",
    cta: "Explore Security",
    link: "/solutions/security-solutions",
  },
  {
    id: 2,
    tag: "Infrastructure Solutions",
    image: "https://images.unsplash.com/photo-1639066648921-82d4500abf1a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwzfHxzZXJ2ZXIlMjB0ZWNobm9sb2d5fGVufDB8fHx8MTc5MDQyNjQ2MHww&ixlib=rb-4.1.0&q=85",
    title: ["Infrastructure That", "Scales With Your", "Ambition"],
    subtitle: "Intelligent, resilient and always ready. Data centers to edge, built to perform.",
    cta: "Explore Infrastructure",
    link: "/solutions/infrastructure-solutions",
  },
  {
    id: 3,
    tag: "Data & AI",
    image: "https://images.unsplash.com/photo-1639322537228-f710d846310a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHw0fHxuZXR3b3JrJTIwdGVjaG5vbG9neXxlbnwwfHx8fDE3OTA0MjY0NTZ8MA&ixlib=rb-4.1.0&q=85",
    title: ["Turn Enterprise Data", "Into Decisions", "With AI"],
    subtitle: "Insights that move business. From data engineering to enterprise GenAI.",
    cta: "Explore Data & AI",
    link: "/solutions/data-ai",
  },
];

export const stats = [
  { value: 3200, suffix: "+", label: "Cr Turnover" },
  { value: 520, suffix: "+", label: "Locations" },
  { value: 4500, suffix: "+", label: "Employees" },
];

export const partnerRows = [
  [
    { name: "Cisco", logo: "https://teamcomputers.com/wp-content/uploads/2025/06/Group-48097179-2.svg" },
    { name: "Dell Technologies", logo: "https://teamcomputers.com/wp-content/uploads/2025/06/Group-48097187.svg" },
    { name: "Nutanix", logo: "https://teamcomputers.com/wp-content/uploads/2025/06/Group-48097189.svg" },
    { name: "Logitech", logo: "https://teamcomputers.com/wp-content/uploads/2025/06/Group-48097185.svg" },
    { name: "Google Cloud", logo: "https://teamcomputers.com/wp-content/uploads/2025/06/Group-48097182.svg" },
    { name: "HP", logo: "https://teamcomputers.com/wp-content/uploads/2025/06/Group-48097191.svg" },
    { name: "HPE", logo: "https://teamcomputers.com/wp-content/uploads/2025/06/Group-48097188.svg" },
    { name: "Android Enterprise", logo: "https://teamcomputers.com/wp-content/uploads/2026/04/Android-logo-1.png" },
    { name: "NVIDIA", logo: "https://teamcomputers.com/wp-content/uploads/2025/10/nvidia.png" },
  ],
  [
    { name: "Microsoft Surface", logo: "https://teamcomputers.com/wp-content/uploads/2026/05/Microsoft_Surface_logo.svg.png" },
    { name: "Samsung", logo: "https://teamcomputers.com/wp-content/uploads/2025/06/Group-48097183.svg" },
    { name: "Lenovo", logo: "https://teamcomputers.com/wp-content/uploads/2025/06/Group-48097186.svg" },
    { name: "Meta", logo: "https://teamcomputers.com/wp-content/uploads/2025/06/Group-48097190.svg" },
    { name: "Acer", logo: "https://teamcomputers.com/wp-content/uploads/2025/06/path2.svg" },
    { name: "AWS", logo: "https://teamcomputers.com/wp-content/uploads/2025/06/Group-48097184.svg" },
    { name: "Google Workspace", logo: "https://teamcomputers.com/wp-content/uploads/2026/05/gw-scaled.png" },
    { name: "Huawei", logo: "https://teamcomputers.com/wp-content/uploads/2026/05/huawei-logo.png" },
    { name: "Office 365", logo: "https://teamcomputers.com/wp-content/uploads/2025/10/Office365.png" },
  ],
  [
    { name: "Qlik", logo: "https://teamcomputers.com/wp-content/uploads/2025/10/QlikQ.png" },
    { name: "Tableau", logo: "https://teamcomputers.com/wp-content/uploads/2025/10/tableau.png" },
    { name: "LG", logo: "https://teamcomputers.com/wp-content/uploads/2025/10/lg.png" },
    { name: "Fortinet", logo: "https://teamcomputers.com/wp-content/uploads/2025/10/FORTINET.png" },
    { name: "Check Point", logo: "https://teamcomputers.com/wp-content/uploads/2025/10/checkpoint.png" },
    { name: "JumpCloud", logo: "https://teamcomputers.com/wp-content/uploads/2026/05/JumpCloud-Logo-One-Color-scaled-1.png" },
    { name: "Jamf", logo: "https://teamcomputers.com/wp-content/uploads/2025/10/jamf.png" },
    { name: "SentinelOne", logo: "https://teamcomputers.com/wp-content/uploads/2025/10/sentinelone.png" },
    { name: "Zscaler", logo: "https://teamcomputers.com/wp-content/uploads/2025/10/zscaler.png" },
  ],
];

export const solutions = [
  {
    slug: "infrastructure-solutions",
    title: "Infrastructure Solutions",
    image: "https://images.unsplash.com/photo-1682559736721-c2e77ff4c650?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHw0fHxkYXRhJTIwY2VudGVyfGVufDB8fHx8MTc5MDQyNjUxM3ww&ixlib=rb-4.1.0&q=85",
    short: "Transform legacy systems with scalable, high-performance IT infrastructure that enhances efficiency and business agility.",
    overview: "ZoofyTechX designs, deploys and manages modern IT infrastructure that keeps your enterprise always-on. From data centers to end-user computing, we build foundations that scale with your ambition.",
    offerings: ["Data center modernization", "End-user computing & workplace", "Network design & SD-WAN", "Hybrid infrastructure management", "IT asset lifecycle services"],
  },
  {
    slug: "cloud-solutions",
    title: "Cloud Solutions",
    image: "https://images.unsplash.com/photo-1667670778881-537035257bd8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHw0fHxkaWdpdGFsJTIwdGVjaG5vbG9neXxlbnwwfHx8fDE3OTA0MjY1MTN8MA&ixlib=rb-4.1.0&q=85",
    short: "Leverage secure, scalable cloud solutions for storage, computing, and collaboration, tailored to your business needs.",
    overview: "From migration to FinOps, ZoofyTechX helps you move to the cloud with confidence across AWS, Azure and Google Cloud, optimizing cost, performance and security at every step.",
    offerings: ["Cloud migration & modernization", "Multi-cloud architecture", "Cloud security & governance", "FinOps & cost optimization", "Cloud-native app development"],
  },
  {
    slug: "managed-services",
    title: "Managed Services",
    image: "https://images.unsplash.com/photo-1648611648035-805e9ae87437?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHw0fHxuZXR3b3JrJTIwb3BlcmF0aW9uc3xlbnwwfHx8Ymx1ZXwxNzkwNDI2NTAyfDA&ixlib=rb-4.1.0&q=85",
    short: "Optimize and maintain your IT infrastructure with 24/7 monitoring, performance management, and end-to-end support.",
    overview: "Our NOC and SOC teams monitor, manage and optimize your IT estate around the clock, so your teams can focus on the business instead of firefighting.",
    offerings: ["24/7 NOC & SOC operations", "ITIL-based service desk", "Proactive monitoring & AIOps", "Patch & vulnerability management", "SLA-driven support"],
  },
  {
    slug: "staffing-solutions",
    title: "Staffing Solutions",
    image: "https://images.unsplash.com/photo-1600132806370-bf17e65e942f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHx0ZWNobm9sb2d5JTIwZGFzaGJvYXJkfGVufDB8fHxibHVlfDE3OTA0MjY1MDJ8MA&ixlib=rb-4.1.0&q=85",
    short: "Specialized tech staffing delivers skilled professionals, cutting hiring costs, speeding recruitment, and lowering attrition.",
    overview: "ZoofyTechX staffs niche technology talent at speed — from cloud architects to data engineers — with flexible engagement models that fit your roadmap and budget.",
    offerings: ["Contract & permanent staffing", "Build-operate-transfer models", "Niche tech hiring", "Volume hiring drives", "Payroll & compliance"],
  },
  {
    slug: "annual-maintenance-contract",
    title: "Annual Maintenance Contract",
    image: "https://images.unsplash.com/flagged/photo-1579274216947-86eaa4b00475?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwyfHxkYXRhJTIwY2VudGVyfGVufDB8fHx8MTc5MDQyNjUxM3ww&ixlib=rb-4.1.0&q=85",
    short: "Ensure uninterrupted operations with proactive IT maintenance, regular system health checks, and dedicated support.",
    overview: "Keep your IT estate healthy with comprehensive AMC coverage — preventive maintenance, rapid break-fix and guaranteed uptime across 520+ locations.",
    offerings: ["Preventive maintenance", "Break-fix support", "Multi-vendor coverage", "Spare pool management", "Uptime guarantees"],
  },
  {
    slug: "data-ai",
    title: "Data & AI",
    image: "https://images.unsplash.com/photo-1650327034581-1711a15a5430?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxkYXRhJTIwYW5hbHl0aWNzfGVufDB8fHxibHVlfDE3OTA0MjY1MDh8MA&ixlib=rb-4.1.0&q=85",
    short: "Unlock actionable insights with advanced analytics and AI-driven data solutions to drive smarter business decisions.",
    overview: "From data engineering to enterprise GenAI, ZoofyTechX builds the pipelines, platforms and practices that turn raw data into competitive advantage.",
    offerings: ["Data engineering & platforms", "BI & visualization (Qlik, Tableau)", "GenAI & ML solutions", "Data governance & quality", "AI strategy & consulting"],
  },
  {
    slug: "security-solutions",
    title: "Security Solutions",
    image: "https://images.unsplash.com/photo-1488590528505-98d2b5aba04b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwyfHxjeWJlcnNlY3VyaXR5fGVufDB8fHxibHVlfDE3OTA0MjY1MDh8MA&ixlib=rb-4.1.0&q=85",
    short: "Comprehensive security solutions protect networks, identities, data, and operations while ensuring compliance and resilience.",
    overview: "ZoofyTechX secures your enterprise end-to-end — network, identity, endpoint and cloud — with zero-trust architectures and 24/7 threat response.",
    offerings: ["Zero-trust architecture", "Managed detection & response", "Identity & access management", "Endpoint & network security", "Compliance & risk (DPDP, ISO)"],
  },
  {
    slug: "erp-business-applications",
    title: "ERP & Business Applications",
    image: "https://images.unsplash.com/photo-1660144425546-b07680e711d1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHw0fHx0ZWNobm9sb2d5JTIwZGFzaGJvYXJkfGVufDB8fHxibHVlfDE3OTA0MjY1MDJ8MA&ixlib=rb-4.1.0&q=85",
    short: "Streamline operations with customized ERP solutions that enhance automation, efficiency, and decision-making.",
    overview: "We implement, customize and support ERP and business applications that automate operations and give leaders a single source of truth.",
    offerings: ["ERP implementation & rollout", "CRM & business apps", "Workflow automation", "Integration & APIs", "Application support & AMS"],
  },
];

export const industries = [
  { slug: "banking-insurance", name: "Banking and Insurance", icon: "ShieldCheck", blurb: "Secure, compliant digital cores for BFSI and NBFC leaders." },
  { slug: "automotive", name: "Automotive", icon: "Car", blurb: "Connected factories, dealer networks and smart mobility IT." },
  { slug: "healthcare-pharma", name: "Healthcare and Pharma", icon: "HeartPulse", blurb: "Resilient IT for hospitals, labs and life-sciences compliance." },
  { slug: "manufacturing", name: "Manufacturing", icon: "Factory", blurb: "Industry 4.0 infrastructure, OT-IT convergence and analytics." },
  { slug: "retail", name: "Retail", icon: "ShoppingCart", blurb: "Omnichannel platforms, stores IT and supply-chain visibility." },
  { slug: "it-ites", name: "IT/ITES", icon: "Cpu", blurb: "Scale engineering capacity and delivery infrastructure fast." },
  { slug: "media", name: "Media", icon: "Megaphone", blurb: "High-performance workflows for content, broadcast and OTT." },
  { slug: "startups", name: "Startups", icon: "Rocket", blurb: "Right-sized, pay-as-you-grow IT for high-velocity teams." },
];

export const jobs = [
  { id: 1, title: "Cloud Solutions Architect", location: "Gurugram", type: "Full-time", team: "Cloud" },
  { id: 2, title: "SOC Analyst (L2)", location: "Mumbai", type: "Full-time", team: "Security" },
  { id: 3, title: "Data Engineer - Databricks", location: "Bengaluru", type: "Full-time", team: "Data & AI" },
  { id: 4, title: "IT Field Support Engineer", location: "Pune", type: "Full-time", team: "Managed Services" },
  { id: 5, title: "Enterprise Account Manager", location: "Delhi NCR", type: "Full-time", team: "Sales" },
  { id: 6, title: "GenAI Solutions Consultant", location: "Hyderabad", type: "Full-time", team: "Data & AI" },
];
